import { styled } from 'styled-components';


export default styled.section`
    padding: 6rem 0;
    
    .img-con{
        position: relative;
        margin: auto;
        aspect-ratio: 4/3;
        max-height: 400px;
        margin-inline-end: 1.5rem;

        img{
            border-radius: 16px;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

    }

    .content-con{
        display: flex;
        align-items: center;
    }

   .title{
        font-family: var(--ftl);
        font-size: 2.5rem;
        line-height: 3rem;
        text-align: start;
        letter-spacing: 0.02em;
        color: #222222;
        font-weight: 600;
        word-spacing: -0.2rem;
        margin-bottom: 1rem;
   }

   .text{
        font-family: var(--ftl);
        font-style: normal;
        font-weight: 300;
        font-size: 1.125rem;
        line-height: 2.1rem;
        text-align: right;
        letter-spacing: 0.015em;
        color: #7F7F7F;
        margin-bottom: 1.5rem;
   }

   .btn-con{
        padding-top: .8rem;
   }

   .btn-con a{
        background: var(--primary);
        color: #fff;
        padding: .5rem 2rem;
        text-decoration: none;
        font-family: var(--ftl);
        font-size: 1.1rem;
        border-radius: 4px;
        letter-spacing: 0.03rem;
        transition: all .15s ease-in-out;

        &:hover{
            background-color: var(--primary-hover);
        }
   }

   .btn-con svg{
        margin-right: 0.3rem;
   }

    @media (max-width: 991px){
        padding: 4rem 0;
        
        .img-con{
            margin-bottom: 2rem;
            width: auto !important;
            margin-inline: auto;
        }

        .title,
        .text{
            text-align: center;
        }

        .btn-con {
            display: flex;
            justify-content: center;
        }

    }

   @media (max-width: 767px){

        .img-con{
            margin-bottom: 1.5rem;
        }
   }

   @media (max-width: 576px){
    padding: 4rem 1.5rem;

    .img-con{
        border-radius: 12px;
    }

    .content-con{
        .content{
            .title{
                font-size: 2.25rem;
                margin-bottom: .75rem;
            }
        }
    }



   }

`